import { render, staticRenderFns } from "./Retail.vue?vue&type=template&id=a5035466&scoped=true&"
import script from "./Retail.vue?vue&type=script&lang=js&"
export * from "./Retail.vue?vue&type=script&lang=js&"
import style0 from "./Retail.vue?vue&type=style&index=0&id=a5035466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5035466",
  null
  
)

export default component.exports